function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint react:true, es6:true, node:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports;
  if (is_node) ;else ;
  define(['virt_jquery_all', 'hola_opt', '/util/url.js', '/util/etask.js', '/util/user_agent.js', '/www/hola/pub/util.js', '/svc/account/pub/membership.js', '/util/version_util.js', '/www/hola/pub/app_checker.js', '/util/escape.js', 'cookie', 'svc_versions', '/www/hola/pub/site_load.js', '/www/hola/pub/gtm.ts', '/util/date.js', '/util/sprintf.js', 'pub_config', '/util/string.js', '/www/hola/pub/client_hints_global.ts', '/util/fetch.js'], ($, hopt, zurl, etask, user_agent, www_util, membership, version_util, app_checker, zescape, cookie, versions, site_load, gtm, date, sprintf, {
    ccgi_url
  }, {
    qw
  }, {
    guess_os_and_version
  }, {
    fetch
  }) => {
    var E = {
      t: {}
    };
    var b = user_agent.guess_browser(),
      sys = user_agent.guess();
    var qs_o = () => zurl.qs_parse(location.search.substr(1), {
      safe: true
    });
    var assign = Object.assign;
    E.t.exe_instruct_timeout = 10000;
    E.t.track_exe_timeout = 20000;
    E.t.sys_ver_cmp = ver => version_util.cmp(sys.version, ver);
    E.is_paid = ctx => membership.is_active(ctx.membership) && !membership.is_in_trial(ctx.membership);
    E.get_pay_url = id => {
      var params = {
        ref: 'homepage',
        next: 'http://hola.org/cp?ref=payment'
      };
      if (id && id != 'free') params.plan_id = id;
      return zescape.uri('/premium', params);
    };
    E.get_filename = opt => www_util.get_exe_filename(hopt, guess_os_and_version(), versions, opt).replace(/\?.*/, '');
    E.get_exe_link = opt => www_util.get_exe_link(hopt, guess_os_and_version(), versions, opt);
    E.get_link = opt => {
      var has_svc = opt.has_svc,
        svc_info = opt.svc_info,
        item = opt.item;
      var name = item.name,
        href = item.href;
      if (['mac_beta', 'mac', 'windows'].includes(name)) {
        return E.get_exe_link({
          has_svc,
          svc_info,
          os: name == 'windows' ? 'windows' : 'macos'
        });
      }
      return href ? href : `/download/${name}`;
    };
    var rename_from_translation = (url, file_name) => {
      var _url$split = url.split('?'),
        _url$split2 = _slicedToArray(_url$split, 2),
        base_path = _url$split2[0],
        query = _url$split2[1];
      var last_slash_index = base_path.lastIndexOf('/');
      var dir = last_slash_index !== -1 ? base_path.substring(0, last_slash_index + 1) : '';
      var prod = query && /Browser/.test(query) ? 'Browser' : 'Setup';
      if (file_name.indexOf('Hola-Setup') === 0) file_name = file_name.replace('Hola-Setup', 'g');
      var new_name = `Hola-${prod}-ads-${file_name}.exe`;
      return dir + new_name + (query ? '?' + query : '');
    };
    var download_file = (link, filename) => {
      var l = link;
      var campaign = [cookie.get('c_vpn'), cookie.get('c_browser')].filter(c => c && !['organic', 'hp'].includes(c));
      if (!campaign.length && filename && /.exe/.test(link)) {
        var file_name = /\./.test(filename) ? filename.split('.')[0] : filename;
        l = rename_from_translation(link, file_name);
      }
      if (/exe/.test(l)) {
        var parsed = zurl.parse(l, true);
        l = `https://${window.location.host}/download_win` + parsed.search.split('&product=')[0] + '&file=' + parsed.file.split('.exe')[0] + '&v=' + (parsed.directory.includes('2') ? '2' : '1');
      }
      var iframe = document.createElement('iframe');
      iframe.width = 0;
      iframe.height = 0;
      iframe.className = 'hide';
      iframe.src = l;
      document.body.append(iframe);
    };
    E.download_file = download_file;
    E.track_download = opt => {
      var name = opt.name || 'unknown';
      var origin_name = opt.origin_name || 'unknown';
      var url = opt.url;
      var page_url = opt.page_url || location.href;
      var build = {};
      if (!cookie.get('c_browser') && !cookie.get('c_vpn') && location.pathname == '/') {
        build.campaign = 'hp';
      }
      return www_util.perr({
        id: 'www_track_download',
        info: {
          name: name,
          url: url,
          page_url: page_url,
          browser: b,
          silent: opt.silent,
          agree: opt.agree,
          ext_installed: opt.ext_installed,
          ext_skip_first_run: opt.ext_skip_first_run,
          exe_redirect: opt.exe_redirect,
          origin_name: origin_name,
          install_opt: opt.install_opt
        },
        build
      });
    };
    var send_analytics = (category, action, label) => {
      if (action == 'next_step') return;
      if (action == 'start_install') gtm.push({
        event: 'install_start'
      });
      if (action == 'ext_redirect_to_store') gtm.push({
        event: 'install_extension'
      });
    };
    E.install_perr = (action, ctx = {}, opt = {}) => {
      var category = 'www_install_flow';
      var label = opt.name;
      opt.id = category + (label ? '_' + label : '') + '_' + action;
      opt.env = $.extend({
        location_url: location.href,
        referrer: document.referrer,
        embedded: window.top != window
      }, ctx.env);
      send_analytics(category, action, label);
      return etask(function* () {
        var ext_info = yield app_checker.get_ext_info();
        var uuid = ext_info && ext_info.uuid || qs_o().uuid;
        opt = $.extend({
          uuid: uuid
        }, opt);
        opt.info = $.extend({}, opt.info, {
          source: opt.source,
          env: ctx.env
        });
        return www_util.perr(opt);
      });
    };
    var track_count_limit = 120;
    var track_exe_status = (ctx, opt) => {
      if (!opt) opt = {};
      var is_install_started,
        next_step_timer,
        count = 0;
      var next_step_et = etask.wait();
      var goto_next_step = perr_name => {
        clearTimeout(next_step_timer);
        E.install_perr(perr_name, ctx, {
          name: 'exe'
        });
        next_step_et.break(perr_name);
      };
      if (!opt.wait_forever) {
        next_step_timer = setTimeout(() => {
          goto_next_step('exe_timeout');
        }, E.t.track_exe_timeout);
      }
      etask.for(null, () => ++count && etask.sleep(1000), [function try_catch$() {
        return $.ajax({
          type: 'POST',
          dataType: 'json',
          url: '//' + ccgi_url + '/client_cgi/win_install_init.json'
        });
      }, function (e) {
        if (typeof window != 'undefined' && window._test_for_goto_next_step) {
          goto_next_step(window._test_for_goto_next_step);
          return this.break();
        }
        if (!e || !e.item || e.name != 'exe') return;
        if (count > track_count_limit && !opt.wait_forever) {
          goto_next_step('exe_too_long');
          return this.break();
        }
        if (e.item.install_err_time) {
          goto_next_step('exe_error');
          return this.break();
        }
        if (!is_install_started && (e.item.install_start_time || e.item.install_web_start_time)) {
          is_install_started = true;
          goto_next_step('exe_installing');
        }
        if (e.item.cid_set_time) {
          goto_next_step('exe_installed');
          return this.break();
        }
      }]);
      return next_step_et;
    };
    E.track_exe_status = track_exe_status;
    E.download_exe = (ctx, opt = {}) => {
      var sp_track_exe;
      E.install_perr('download', ctx, opt);
      return etask(function* () {
        this.on('finally', () => {
          if (sp_track_exe) sp_track_exe.return();
        });
        var skip_first_run = !(ctx.env.is_ie || ctx.env.is_chrome || ctx.env.is_edge || ctx.env.is_chromium_edge);
        download_file(E.get_exe_link(opt));
        var silent = !hopt.www_hola.disable_silent_install;
        E.track_download({
          name: 'exe',
          install_opt: opt,
          ext_skip_first_run: skip_first_run,
          exe_redirect: opt.ext_exe && opt.ext_exe.exe_redirect,
          silent: silent,
          agree: silent && opt.agree
        });
        this.spawn(track_exe_status(ctx, opt));
        this.spawn(app_checker.wait_for_new_svc());
        yield this.wait_child('any');
      });
    };
    E.download_ext = (ctx, opt) => {
      return etask(function* () {
        E.install_perr('download', ctx, opt);
        var url = www_util.download_url.firefox_signed;
        if (window.InstallTrigger) {
          // XXX arik/dmitriyr: use Install_Object to handle success/cancel
          // events: https://developer.mozilla.org/en-US/docs/Archive/Mozilla/XPInstall/Reference/Install_Object
          window.InstallTrigger.install({
            Hola: url
          });
        } else download_file(url);
        yield app_checker.wait_for_new_ext(!!document.referrer);
      });
    };
    var check_exe_skip = ctx => {
      if (ctx.env.is_safari || qs_o().aff == 'StackCommerce') return true;
      if (ctx.env.is_win && qs_o().test == 'exe_flow') return false;
      return E.is_paid(ctx);
    };
    E.t.need_exe = (ctx, opt) => {
      if (!opt) opt = {};
      var skip = check_exe_skip(ctx);
      var env = ctx.env,
        need_exe = ctx.need_exe,
        is_latest_svc = ctx.is_latest_svc,
        type = ctx.type;
      return !!(!skip && (env.is_win && !env.is_ie && !env.is_edge || env.is_mac && E.t.sys_ver_cmp('10.9') >= 0) && !is_latest_svc && type != 'ext' && need_exe && !env.is_chromium_edge);
    };
    E.need_agree = ctx => {
      return !!(hopt.www_hola.check_agree_ts && ctx.env.is_win && !E.t.need_exe(ctx) && ctx.svc_info.ver && !ctx.reg_info.agree_ts && version_util.cmp(ctx.svc_info.ver, '1.120.691') >= 0);
    };
    E.need_choose_plan = ctx => {
      return ctx.type != 'ext' && E.t.need_exe(ctx) && !E.is_paid(ctx) || E.need_agree(ctx);
    };
    E.t.need_run_exe = ctx => !check_exe_skip(ctx) && ctx.env.is_mac && ctx.env.is_safari && E.t.sys_ver_cmp('10.9') >= 0;
    E.t.need_ext = ({
      env,
      is_installed_ext
    }) => env.is_desktop && !env.is_ie && !env.is_edge && !is_installed_ext && !env.is_safari;
    E.need_unsupported_ext = ctx => ctx.env.is_mac && ctx.env.is_safari && !E.t.need_run_exe(ctx);
    E.complete = (ctx = {}, opt = {}) => {
      if (ctx.on_complete) ctx.on_complete();
      var flow = opt.flow,
        redirect_to_store = opt.redirect_to_store;
      var _ref = ctx.env || {},
        is_desktop = _ref.is_desktop,
        is_ie = _ref.is_ie,
        is_edge = _ref.is_edge,
        is_safari = _ref.is_safari,
        is_chrome = _ref.is_chrome,
        is_ff = _ref.is_ff,
        is_opera = _ref.is_opera;
      var dl = site_load.select_dl(undefined, flow || 'vpn', E.is_paid(ctx));
      if (redirect_to_store && E.t.need_ext(ctx)) {
        var ff_store_url = 'https://addons.mozilla.org/en-US/firefox/addon/' + 'hola-free-vpn-proxy-unblocker/';
        E.install_perr('ext_redirect_to_store', ctx, {
          name: 'ext'
        });
        E.install_perr('complete', ctx, assign(opt, {
          info: redirect_to_store
        }));
        var gdl = is_opera && site_load.GDL.opera || is_edge && site_load.GDL.edge || site_load.GDL[b.browser];
        var href = is_ff && ff_store_url || gdl && gdl.url || dl.url;
        if (ctx.force_store_redirect) return window.open(href, '_blank');
        return location.href = href;
      }
      if (is_desktop && (!flow || flow == 'vpn')) {
        www_util.perr({
          id: 'www_vpn_install_free_step_done_9'
        });
        E.install_perr('complete', ctx, opt);
        location.href = is_ie || is_edge ? 'https://hola.org/download' : 'https://hola.org/access/popular';
        return;
      }
      if (is_desktop && is_safari) return location.href = '/mac';
      var _url;
      if (is_chrome) {
        if (flow == 'adblock') _url = site_load.GDL[is_edge ? 'edge' : 'chrome'].adremover_url;else if (flow == 'accelerator') _url = site_load.GDL.chrome.va_url;else _url = dl.url;
      } else _url = dl.url;
      return void window.open(_url, '_top');
    };
    E.get_env = () => ({
      is_win: sys.os == 'windows',
      is_mac: sys.os == 'macos',
      is_nix: !!sys.nix,
      is_desktop: sys.os == 'windows' || sys.os == 'macos' || !!sys.nix,
      is_mobile: sys.mobile,
      is_ie: b.browser == 'ie',
      is_edge: b.browser == 'edge',
      is_chrome: b.browser == 'chrome' && !b.opera && !b.edge,
      is_opera: !!b.opera,
      is_chromium_edge: b.browser == 'chrome' && !!b.edge,
      is_safari: b.browser == 'safari',
      is_ff: b.browser == 'firefox'
    });
    E.get_app_data = () => {
      return etask(function* () {
        try {
          var res = yield etask.all([app_checker.is_latest_ext(), app_checker.is_latest_svc(), app_checker.get_ext_info(), app_checker.is_ext(), app_checker.is_svc()]);
          var ext_info = res[2] || {};
          var _yield$etask$all = yield etask.all({
              ext: app_checker.is_ext(),
              svc: app_checker.is_svc()
            }),
            ext = _yield$etask$all.ext,
            svc = _yield$etask$all.svc;
          return {
            is_latest_ext: res[0],
            is_latest_svc: res[1],
            is_installed_ext: res[3],
            is_installed_svc: svc,
            is_app_installed: ext && svc,
            ext_info,
            uuid: ext_info.uuid
          };
        } catch (e) {
          console.error(e);
        }
      });
    };
    var get_svc_reg_info = () => {
      return etask(function* () {
        try {
          var res = yield etask.all([app_checker.get_registry_info(), app_checker.get_svc_info()]);
          return {
            reg_info: res[0] || {},
            svc_info: res[1] || {}
          };
        } catch (e) {
          console.error(e);
        }
      });
    };
    var get_user = () => etask(function* () {
      var user = cookie.getJSON('user') || {};
      if (!user.display_name) {
        var res = yield www_util.get_user({
          source: 'download',
          cache: true
        });
        user = res && res.user || null;
      }
      return user;
    });
    E.need_step = (name, ctx, opt) => {
      var fn = {
        agree: () => opt.need_agree,
        choose_plan: E.need_choose_plan,
        exe: E.t.need_exe,
        run_exe: E.t.need_run_exe,
        ext: E.t.need_ext,
        unsupported_ext: E.need_unsupported_ext
      }[name];
      return fn ? fn(ctx, opt) : false;
    };
    E.init_ctx = (opt = {}) => {
      var ctx = {};
      var env = opt.env,
        install_src = opt.install_src;
      ctx.env = env || E.get_env();
      ctx.src = install_src || '';
      ctx.force_store_redirect = opt.force_store_redirect;
      if (install_src) {
        cookie.set('install_src', install_src, {
          domain: '.hola.org',
          path: '/',
          expires: date.add(date(), {
            day: 1
          })
        });
      }
      if (!ctx.env.is_desktop) return ctx;
      assign(ctx, {
        need_ext: true,
        need_exe: true
      });
      return etask(function* () {
        assign(ctx, yield E.get_app_data());
        assign(ctx, yield get_svc_reg_info());
        ctx.user = yield get_user();
        ctx.membership = yield www_util.get_membership({
          cache: true
        });
        return ctx;
      });
    };
    E.set_step_hash = step => {
      var hash = `install_flow_${step}`;
      window.history.pushState(null, null, `${document.location.pathname}${document.location.search}#${hash}`);
    };
    E.buttons_sets = {
      browsers: [{
        name: 'chrome',
        href: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
        title: 'Chrome'
      }, {
        name: 'edge',
        title: 'Microsoft Edge',
        href: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf',
        rel: 'windows'
      },
      /* {
          name: 'firefox',
          title: 'Firefox',
          href: 'https://addons.mozilla.org/en-US/firefox/addon/'
          +'hola-vpn-free-secure-proxy/',
      },*/
      {
        name: 'opera',
        title: 'Opera',
        href: 'https://addons.opera.com/en/extensions/details/' + 'hola-better-internet/'
      }],
      platforms: [{
        name: 'android',
        href: 'https://play.google.com/store/apps/details?' + 'id=org.hola.play',
        title: 'Android'
      }, {
        name: 'ios',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=iphone',
        title: 'iOS'
      }, {
        name: 'huawei',
        href: 'https://appgallery.huawei.com/#/app/C102688195',
        title: 'Huawei'
      }, {
        name: 'samsung',
        href: 'https://galaxystore.samsung.com/detail/org.hola.samsung',
        title: 'Samsung'
      }, {
        name: 'windows',
        href: '/download',
        title: 'Windows'
      }, {
        name: 'mac_beta',
        href: '/download/mac',
        title: 'Mac'
      }],
      game_platforms: [{
        name: 'xbox',
        href: '/plus_setup?platform=console&type=xbox_one',
        title: 'Xbox',
        tooltip_pos: 'bottom'
      }, {
        name: 'playstation',
        href: '/plus_setup?platform=console&type=ps4',
        title: 'Playstation',
        tooltip_pos: 'bottom'
      }, {
        name: 'console',
        href: '/plus_setup?platform=console',
        title: 'Consoles',
        tooltip_pos: 'bottom'
      }, {
        name: 'router',
        href: '/plus_setup?platform=router',
        title: 'Routers',
        tooltip_pos: 'bottom'
      }, {
        name: 'appletv',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=appleTV',
        title: 'Apple TV',
        tooltip_pos: 'bottom'
      }, {
        name: 'smarttv',
        href: 'https://support.hola.org/en/collections/10103755-smart-tv',
        title: 'Smart TV',
        tooltip_pos: 'bottom'
      },
      /* {
          name: 'androidtv',
          href: '//'+hopt.www_hola.apk_cdn+'/static/Hola-Setup-'
              +versions.android+'.Tv.apk',
          button_text: 'Download APK',
          href: 'https://play.google.com/store/apps/details?'
          +'id=org.hola.play',
          title: 'Android TV',
          tooltip_pos: 'bottom',
      }, */
      {
        name: 'firetv',
        href: 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/' + 'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8',
        title: 'Fire TV',
        tooltip_pos: 'bottom'
      }, {
        name: 'lg',
        href: 'https://us.lgappstv.com/main/tvapp/detail?appId=1094740&' + 'catCode1=003&moreYn=N&cateYn=Y&orderType=0&headerName=' + 'Entertainment&appRankCode=&sellrUsrNo=&curPage=22',
        title: 'LG',
        tooltip_pos: 'bottom'
      }],
      premium_setup: [{
        name: 'windows',
        title: 'Windows',
        href: '/plus_setup?platform=windows',
        versions_text: 'Please select your OS version',
        versions: [{
          name: '7',
          title: 'Windows 7'
        }, {
          name: '8',
          title: 'Windows 8'
        }, {
          name: '10',
          title: 'Windows 10'
        }, {
          name: '11',
          title: 'Windows 11'
        }]
      }, {
        name: 'mac',
        title: 'MacOS',
        href: '/plus_setup?platform=mac'
      }, {
        name: 'android',
        title: 'Android',
        href: '/plus_setup?platform=android',
        versions_text: 'Please specify the device',
        versions: [{
          name: 'android',
          title: 'Android'
        }, {
          name: 'samsung',
          title: 'Samsung'
        }, {
          name: 'huawei',
          title: 'Huawei'
        }]
      }, {
        name: 'ios',
        title: 'iPhone, iPad and Apple TV',
        href: '/plus_setup?platform=ios'
      }, {
        name: 'smarttv',
        title: 'Smart TV',
        href: '/plus_setup?platform=smarttv',
        versions_text: 'Please select your TV manufacturer',
        versions: [{
          name: 'lg',
          title: 'LG'
        }, {
          name: 'panasonic',
          title: 'Panasonic'
        }, {
          name: 'philips',
          title: 'Philips'
        }, {
          name: 'samsung',
          title: 'Samsung'
        }, {
          name: 'sony',
          title: 'Sony'
        }, {
          name: 'toshiba',
          title: 'Toshiba'
        }, {
          name: 'appletv',
          title: 'Apple TV'
        }]
      }, {
        name: 'console',
        title: 'Consoles',
        href: '/plus_setup?platform=console',
        versions_text: 'Please select your device model',
        versions: [{
          name: 'ps4',
          title: 'Playstation 4'
        }, {
          name: 'ps_vita',
          title: 'Nintendo Switch'
        }, {
          name: 'xbox_one',
          title: 'Xbox One'
        }],
        tooltip_pos: 'bottom'
      }, {
        name: 'router',
        title: 'Routers',
        href: '/plus_setup?platform=router',
        versions_text: 'Please select your device model',
        versions: [{
          name: 'keeneticu',
          title: 'Keenetic Ultra'
        }],
        tooltip_pos: 'bottom'
      }, {
        name: 'ie',
        title: 'Internet Explorer',
        href: '/plus_setup?platform=ie',
        tooltip_pos: 'bottom'
      }, {
        name: 'edge',
        title: 'Edge',
        href: '/plus_setup?platform=edge',
        install_href: 'https://www.microsoft.com/en-us/edge',
        store: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf',
        tooltip_pos: 'bottom'
      },
      /* {
          name: 'firefox',
          title: 'Firefox',
          href: '/plus_setup?platform=firefox',
          install_href: 'https://www.mozilla.org/firefox/',
          store: 'https://addons.mozilla.org/en-US/firefox/addon/'
          +'hola-vpn-free-secure-proxy/',
          tooltip_pos: 'bottom',
      },*/
      {
        name: 'chrome',
        title: 'Chrome',
        href: '/plus_setup?platform=chrome',
        install_href: 'https://www.google.com/chrome/',
        store: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
        tooltip_pos: 'bottom'
      }, {
        name: 'opera',
        title: 'Opera',
        href: '/plus_setup?platform=opera',
        install_href: 'https://www.opera.com/',
        store: 'https://addons.opera.com/en-gb/extensions/details/' + 'hola-better-internet/',
        tooltip_pos: 'bottom'
      }]
    };
    E.hola_apps = {
      browsers: [{
        name: 'chrome',
        href: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
        title: 'Chrome'
      },
      /* {
          name: 'firefox',
          title: 'Firefox',
          href: 'https://addons.mozilla.org/en-US/firefox/addon/'
              +'hola-vpn-free-secure-proxy/',
      },*/
      {
        name: 'edge',
        title: 'Microsoft Edge',
        href: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf'
      }, {
        name: 'opera',
        title: 'Opera',
        href: 'https://addons.opera.com/en/extensions/details/' + 'hola-better-internet/'
      }],
      mobile: [{
        name: 'android',
        href: 'https://play.google.com/store/apps/details?' + 'id=org.hola.play',
        title: 'Android'
      }, {
        name: 'ios',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=iphone',
        title: 'iOS'
      }, {
        name: 'huawei',
        href: 'https://appgallery.huawei.com/#/app/C102688195',
        title: 'Huawei'
      }, {
        name: 'samsung',
        href: 'https://galaxystore.samsung.com/detail/org.hola.samsung',
        title: 'Samsung'
      }
      /* {
          name: 'amazon',
          href: 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/'
              +'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8',
          title: 'Amazon',
      },*/],
      desktop: [{
        name: 'windows',
        title: 'Windows'
      },
      /* XXX dmitriiz: when uncomment this check code below:
      Object.defineProperty
      {
          name: 'mac',
          title: 'Mac',
      },*/
      {
        name: 'mac_beta',
        title: 'Mac'
      }],
      tv: [
      /* {
          name: 'androidtv',
          href: '//'+hopt.www_hola.apk_cdn+'/static/Hola-Setup-'
              +versions.android+'.Tv.apk',
          href: 'https://play.google.com/store/apps/details?'
          +'id=org.hola.play',
          title: 'Android TV',
      }, */
      {
        name: 'firetv',
        href: 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/' + 'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8',
        title: 'Fire TV'
      }, {
        name: 'lg',
        href: 'https://us.lgappstv.com/main/tvapp/detail?appId=1094740&' + 'catCode1=003&moreYn=N&cateYn=Y&orderType=0&' + 'headerName=Entertainment&appRankCode=&sellrUsrNo=&curPage=22',
        title: 'LG'
      }, {
        name: 'appletv',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=appleTV',
        title: 'Apple TV'
      }, {
        name: 'smarttv',
        href: 'https://support.hola.org/en/collections/10103755-smart-tv',
        title: 'Smart TV',
        button_text: 'Setup guide'
      }],
      other: [{
        name: 'xbox',
        href: '/plus_setup?platform=console&type=xbox_one',
        title: 'Xbox',
        button_text: 'Setup guide'
      }, {
        name: 'playstation',
        href: '/plus_setup?platform=console&type=ps4',
        title: 'Playstation',
        button_text: 'Setup guide'
      }, {
        name: 'router',
        href: '/plus_setup?platform=router',
        title: 'Routers',
        button_text: 'Setup guide'
      }],
      more: [{
        name: 'adblock',
        href: 'https://chrome.google.com/webstore/detail/' + 'hola-adblock/lalfpjdbhpmnhfofkckdpkljeilmogfl',
        title: 'Hola Ad Remover'
      }, {
        name: 'browser',
        href: '/browser',
        title: 'Hola Browser'
      }, {
        name: 'luminati',
        href: 'https://brightdata.com/?affiliate=' + 'ref_590ad97180f5c1144ce118c8',
        title: 'Proxy for Business'
      }, {
        name: 'shoopit',
        href: 'https://shoopit.com',
        title: 'Shoopit'
      }]
    };
    E.marked_items = [{
      category: ['tv', 'game_platforms'],
      items: ['firetv', 'lg']
    }, {
      category: ['more'],
      items: ['shoopit']
    }];
    ['hola_apps', 'buttons_sets'].forEach(name => {
      E.marked_items.forEach(block => {
        var key = Object.keys(E[name]).find(k => block.category.includes(k));
        if (key !== undefined) {
          E[name][key].filter(p => block.items.includes(p.name)).forEach(p => {
            p.marked = true;
          });
        }
      });
    });

    /*
        param props is an object: {name: prop}
    */
    function def_props(collection, name, props) {
      var index = -1;
      collection.forEach((item, i) => {
        if (item.name == name) index = i;
      });
      if (index >= 0) {
        Object.keys(props).forEach(pname => {
          Object.defineProperty(collection[index], pname, props[pname]);
        });
      }
    }
    def_props(E.hola_apps.desktop, 'windows', {
      href: {
        get: () => www_util.get_exe_link(hopt, {
          version: '7'
        }, versions)
      }
    });
    def_props(E.hola_apps.desktop, 'mac_beta', {
      href: {
        // get: ()=>www_util.get_exe_link(hopt, {os: 'macos'}, versions),
        get: () => www_util.get_exe_link(hopt, {
          os: 'macos',
          beta: true
        }, versions)
      }
    });
    def_props(E.hola_apps.mobile, 'android', {
      href: {
        get: () => {
          if (!hopt.www_hola.link_download_apk) {
            return 'https://play.google.com/store/apps/details?' + 'id=org.hola.play';
          }
          return hopt.www_hola.link_download_apk;
        }
      },
      apk_link: {
        get: () => {
          var tpl = hopt.www_hola.apk_file_tpl || 'Hola-Setup-%s.apk';
          return '//' + hopt.www_hola.apk_cdn + '/static/' + sprintf(tpl, versions.android);
        }
      }
    });
    def_props(E.hola_apps.tv, 'androidtv', {
      href: {
        get: () => {
          if (!hopt.www_hola.link_download_apk_tv) {
            return 'https://play.google.com/store/apps/details?' + 'id=org.hola';
          }
          return hopt.www_hola.link_download_apk_tv;
        }
      },
      apk_link: {
        get: () => {
          var tpl = hopt.www_hola.apk_tv_file_tpl || 'Hola-Setup-%s.Tv.apk';
          return '//' + hopt.www_hola.apk_cdn + '/static/' + sprintf(tpl, versions.android);
        }
      }
    });
    E.get_link_review = id => {
      if (id == 'amazon') {
        return 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/' + 'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8';
      }
      var obj = E.hola_apps.browsers.find(_b => _b.name == id);
      return obj ? obj.href : 'https://hola.org';
    };
    E.open_link = id => {
      window.open(E.get_link_review(id));
    };
    return E;
  });
})();